import { Injectable } from '@angular/core';
import { APP_VERSION } from './version.generated';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  // APP_VERSION comes from version.generated.ts, produced at build time by
  // scripts/generate-app-version.mjs (SEOMS-390 — replaces the webpack
  // DefinePlugin global that the esbuild application builder can't provide).
  private readonly version: string = APP_VERSION;

  getVersion(): string {
    return this.version;
  }
}
